export const ContactInitialState = {
    contact_id: '',
    company_id: '',
    first_name: '',
    last_name: '',
};
